import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class ApiKeyInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    const isGoogleApi = request.url.indexOf('googleapis') !== -1;
    const isZendeskApi = request.url.indexOf('zendesk.com') !== -1;
    return next.handle(
      !isGoogleApi && !isZendeskApi
        ? request.clone({
            setHeaders: {
              'x-api-key': environment.api.key,
            },
          })
        : request
    );
  }
}
